import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ButtonModule} from 'primeng/button';
import {RippleModule} from 'primeng/ripple';
import {SidebarModule} from 'primeng/sidebar';
import {InputTextModule} from 'primeng/inputtext';
import {BadgeModule} from 'primeng/badge';
import {TableModule} from 'primeng/table';
import {DialogModule} from 'primeng/dialog';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {CalendarModule} from 'primeng/calendar';
import {CascadeSelectModule} from 'primeng/cascadeselect';
import {CheckboxModule} from 'primeng/checkbox';
import {ChipsModule} from 'primeng/chips';
import {DropdownModule} from 'primeng/dropdown';
import {InputMaskModule} from 'primeng/inputmask';
import {InputSwitchModule} from 'primeng/inputswitch';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {InputNumberModule} from 'primeng/inputnumber';
import {KnobModule} from 'primeng/knob';
import {KeyFilterModule} from 'primeng/keyfilter';
import {ListboxModule} from 'primeng/listbox';
import {MultiSelectModule} from 'primeng/multiselect';
import {PasswordModule} from 'primeng/password';
import {RadioButtonModule} from 'primeng/radiobutton';
import {SliderModule} from 'primeng/slider';
import {SelectButtonModule} from 'primeng/selectbutton';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {TreeSelectModule} from 'primeng/treeselect';
import {SpeedDialModule} from 'primeng/speeddial';
import {TreeModule} from 'primeng/tree';
import {AccordionModule} from 'primeng/accordion';
import {CardModule} from 'primeng/card';
import {DividerModule} from 'primeng/divider';
import {FieldsetModule} from 'primeng/fieldset';
import {PanelModule} from 'primeng/panel';
import {SplitterModule} from 'primeng/splitter';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {TabViewModule} from 'primeng/tabview';
import {ConfirmPopupModule} from 'primeng/confirmpopup';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {TooltipModule} from 'primeng/tooltip';
import {MenuModule} from 'primeng/menu';
import {TabMenuModule} from 'primeng/tabmenu';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {ToastModule} from 'primeng/toast';
import {CarouselModule} from 'primeng/carousel';
import {GalleriaModule} from 'primeng/galleria';
import {ImageModule} from 'primeng/image';
import {AvatarModule} from 'primeng/avatar';
import {AvatarGroupModule} from 'primeng/avatargroup';
import {BlockUIModule} from 'primeng/blockui';
import { ChipModule } from 'primeng/chip';
import {ProgressBarModule} from 'primeng/progressbar';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ScrollTopModule} from 'primeng/scrolltop';
import { TagModule } from 'primeng/tag';
import {MenubarModule} from 'primeng/menubar';
import {PanelMenuModule} from 'primeng/panelmenu';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {SkeletonModule} from 'primeng/skeleton';
import {EditorModule} from 'primeng/editor';
import {PaginatorModule} from 'primeng/paginator';
import {VirtualScrollerModule} from 'primeng/virtualscroller';
import {StyleClassModule} from 'primeng/styleclass';
import {FileUploadModule} from 'primeng/fileupload';
import {DataViewModule} from 'primeng/dataview';
import {SplitButtonModule} from 'primeng/splitbutton';
import { TreeTableModule } from 'primeng/treetable';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ButtonModule,
    RippleModule,
    SidebarModule,
    InputTextModule,
    TableModule,
    DialogModule,
    AutoCompleteModule,
    CalendarModule,
    CascadeSelectModule,
    CheckboxModule,
    ChipsModule,
    DropdownModule,
    InputMaskModule,
    InputSwitchModule,
    InputTextareaModule,
    InputNumberModule,
    KnobModule,
    KeyFilterModule,
    ListboxModule,
    MultiSelectModule,
    PasswordModule,
    RadioButtonModule,
    SliderModule,
    SelectButtonModule,
    ToggleButtonModule,
    TreeSelectModule,
    SpeedDialModule,
    TreeModule,
    AccordionModule,
    CardModule,
    DividerModule,
    FieldsetModule,
    PanelModule,
    SplitterModule,
    ScrollPanelModule,
    TabViewModule,
    ConfirmPopupModule,
    OverlayPanelModule,
    TooltipModule,
    MenuModule,
    TabMenuModule,
    MessagesModule,
    MessageModule,
    ToastModule,
    CarouselModule,
    GalleriaModule,
    ImageModule,
    AvatarModule,
    AvatarGroupModule,
    BlockUIModule,
    ChipModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    ScrollTopModule,
    TagModule,
    MenubarModule,
    PanelMenuModule,
    ConfirmDialogModule,
    ProgressBarModule,
    SkeletonModule,
    EditorModule,
    PaginatorModule,
    VirtualScrollerModule,
    StyleClassModule,
    FileUploadModule,
    DataViewModule,
    SplitButtonModule,
    TreeTableModule,
    IconFieldModule,
    InputIconModule
  ],
  exports:[
    ButtonModule,
    RippleModule,
    SidebarModule,
    InputTextModule,
    BadgeModule,
    TableModule,
    DialogModule,
    AutoCompleteModule,
    CalendarModule,
    CascadeSelectModule,
    CheckboxModule,
    ChipsModule,
    DropdownModule,
    InputMaskModule,
    InputSwitchModule,
    InputTextareaModule,
    InputNumberModule,
    KnobModule,
    KeyFilterModule,
    ListboxModule,
    MultiSelectModule,
    PasswordModule,
    RadioButtonModule,
    SliderModule,
    SelectButtonModule,
    ToggleButtonModule,
    TreeSelectModule,
    SpeedDialModule,
    TreeModule,
    AccordionModule,
    CardModule,
    DividerModule,
    FieldsetModule,
    PanelModule,
    SplitterModule,
    ScrollPanelModule,
    TabViewModule,
    ConfirmPopupModule,
    OverlayPanelModule,
    TooltipModule,
    MenuModule,
    TabMenuModule,
    MessagesModule,
    MessageModule,
    ToastModule,
    CarouselModule,
    GalleriaModule,
    ImageModule,
    AvatarModule,
    AvatarGroupModule,
    BlockUIModule,
    ChipModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    ScrollTopModule,
    TagModule,
    MenubarModule,
    PanelMenuModule,
    ConfirmDialogModule,
    ProgressBarModule,
    SkeletonModule,
    EditorModule,
    PaginatorModule,
    VirtualScrollerModule,
    StyleClassModule,
    FileUploadModule,
    DataViewModule,
    SplitButtonModule,
    TreeTableModule,
    IconFieldModule,
    InputIconModule
  ]
})
export class PrimengModule { }
